export interface AddressLabel {
  addressee: string;
  name: string;
  line1: string;
  line2: string;
  line3: string;
  line4: string;
  townCity: string;
  region: string;
  postCode: string;
  country: string;
  orderNo: number;
  despatchNoteNo: number;
  autoPrint: boolean;
}
